module.exports = __webpack_public_path__ + "55c242aaa23ff30108991f2eada717ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/green-skateboard.png
// module id = 1580
// module chunks = 0